import { render, staticRenderFns } from "./newsListItem.vue?vue&type=template&id=151884d5&scoped=true&"
import script from "./newsListItem.vue?vue&type=script&lang=js&"
export * from "./newsListItem.vue?vue&type=script&lang=js&"
import style0 from "./newsListItem.vue?vue&type=style&index=0&id=151884d5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151884d5",
  null
  
)

export default component.exports